window.emitLitDebugLogEvents = true;
import "@sakai-ui/sakai-rubrics/sakai-rubric-student-button.js";
import "@sakai-ui/sakai-rubrics/sakai-rubric-student.js";
import "@sakai-ui/sakai-rubrics/sakai-rubric-grading.js";
import "@sakai-ui/sakai-rubrics/sakai-rubric-association.js";
import "@sakai-ui/sakai-rubrics/sakai-rubric-student-preview-button.js";
import "@sakai-ui/sakai-rubrics/sakai-rubrics-utils.js";
